
//Représente la vue d’une achat
export class RetournerVueAchatResultat {
  // Titre
  public titre!: string;

  // Date de la facture
  public dateFacture!: Date;

  // Code du processus métier
  public processusMetier!: string;

  // Dénomination du vendeur
  public vendeur!: string;

  // Montant TTC
  public montantTtc!: number;

  // Date d'échéance
  public dateEcheance!: Date;

  // Reference
  public reference!: string;

  // Identifiant d’adressage du vendeur
  public identifiantAdressageVendeur!: string;

  // Identifiant complémentaire du vendeur
  public identifiantComplementaireVendeur!: string;

  // Montant HT
  public montantHt!: number;
  
  // Montant TVA
  public montantTva!: number;
  
  // Montant Accompte
  public montantAcompte!: number;
  
  // Montant net à payer
  public montantNetAPayer!: number;
  
  // Nombre de jours avant échéance
  public nombreJoursAvantEcheance!: number;

  // Type de pièce en clair : Facture ou Avoir (BT-3)
  public typePiece!: string;

  // Code type de pièce UNTDID 1001 : 380 facture, 381 avoir (BT-3)
  public codeTypePiece!: string;

  // Référence de la facture d'origine, renseignée sur un avoir (BT-25)
  public referenceFactureOrigine!: string | null;
}
